import { render } from "./Libra.vue?vue&type=template&id=3215840b&scoped=true"
import script from "./Libra.vue?vue&type=script&lang=js"
export * from "./Libra.vue?vue&type=script&lang=js"

import "./Libra.vue?vue&type=style&index=0&id=3215840b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3215840b"]])

export default __exports__